import { render, staticRenderFns } from "./ManageFolders.vue?vue&type=template&id=dd88343e&"
import script from "./ManageFolders.vue?vue&type=script&lang=js&"
export * from "./ManageFolders.vue?vue&type=script&lang=js&"
import style0 from "./ManageFolders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports